module.exports = __webpack_public_path__ + "img/pink_key-lg.05e5646d.webp";